import { render, staticRenderFns } from "./SidebarForm.vue?vue&type=template&id=23b3ffb6&scoped=true"
import script from "./SidebarForm.vue?vue&type=script&lang=js"
export * from "./SidebarForm.vue?vue&type=script&lang=js"
import style0 from "./SidebarForm.vue?vue&type=style&index=0&id=23b3ffb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b3ffb6",
  null
  
)

export default component.exports